
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work/[id]",
      function () {
        return require("private-next-pages/work/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work/[id]"])
      });
    }
  